import React, {useEffect, useState} from 'react';
import TableContainer from "@mui/material/TableContainer";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableCell from "@mui/material/TableCell";
import TableBody from "@mui/material/TableBody";
import {Button, Modal, Spin} from "antd";
import {useHistory} from "react-router-dom";
import axios from "axios";
import {API_PATH} from "../../components/const";
import {toast} from "react-toastify";

const AdminCompanies = () => {
    let history = useHistory()
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [offices, setOffices] = useState([])
    const [deleteId, setDeleteId] = useState(null);
    const [tabs, setTabs] = useState(1)
    const [loader, setLoader] = useState(false)

    const showModalDelete = (id) => {
        setIsModalOpen(true);
        setDeleteId(id)
    };

    const handleCancelDelete = () => {
        setIsModalOpen(false);
    };


    const editPage = (id) => {
        history.push("/global-admin/admin-companies/edit/" + id)
    }
    const selectCompany = (id) => {
        setLoader(true)
        localStorage.setItem("for_com", id)
        axios.get(API_PATH + "company/" + id, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res2 => {
                // console.log(localStorage.getItem("token"))
                localStorage.setItem("name", res2?.data?.name)
                localStorage.setItem("description", res2?.data?.description)
                localStorage.setItem("company_type", res2?.data?.type)
                localStorage.setItem("phone", res2?.data?.phone)
                localStorage.setItem("email", res2?.data?.email)
                localStorage.setItem("id", res2?.data?.id)
                localStorage.setItem("owner_id", res2?.data?.owner_id)
                setTimeout(() => {
                    setLoader(false)
                    history.push("/main/visitor-home")
                    window.location.reload()
                }, 500)
            })
    }

    // const importFc = () => {
    //     axios.get(API_PATH + "user/company/" + localStorage.getItem('id') + "/download/example-xlsx-file" , {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
    //         .then(res => {
    //
    //         })
    //         .catch(err => {
    //             toast.error("Ошибка")
    //         })
    // }
    const getData = (type) => {
        axios.get(API_PATH + "company/all?is_active=" + type, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res => {
                setOffices(res.data)
            })
            .catch(err => {
                toast.error("Ошибка")
            })
    }
    const handleOkDelete = () => {
        axios.delete(API_PATH + "company/delete/" + deleteId, {headers: {"Authorization": "Bearer " + localStorage.getItem("token")}})
            .then(res =>{
                setIsModalOpen(false);
                setDeleteId(null)
                if (tabs === 1){
                    getData(true)
                } else {
                    getData(false)
                }
            })
            .catch(err =>{
                toast(err =>{
                    toast.error("Failed")
                })
            })
    };

    useEffect(() => {
        getData(true)
    }, []);
    return (<div className="users">
            <div className="employees-header ">
                <div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="left-head">
                            <h6 className="font-family-medium">Компании</h6>
                            {/*<button onClick={importFc}>123123123</button>*/}
                        </div>
                        <div className="right-head">
                            <button className="add-btn font-family-medium"
                                    onClick={() => history.push("/global-admin/admin-companies/create")}><img
                                src="/icon/plus.svg"/> Добавить новое
                            </button>
                        </div>
                    </div>
                    <div className="col-md-6">
                        <div className="tabs-btns">
                            <button onClick={() => {
                                setTabs(1)
                                getData(true)
                            }}
                                    className={tabs === 1 ? "font-family-medium active" : "font-family-medium"}>Активный
                            </button>
                            <button onClick={() => {
                                setTabs(2)
                                getData(false)
                            }}
                                    className={tabs === 2 ? "font-family-medium active" : "font-family-medium"}> Неактивный
                            </button>
                            <button onClick={() => {
                                setTabs(3)
                            }}
                                    className={tabs === 3 ? "font-family-medium active" : "font-family-medium"}>Новые
                                лиды
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className="emp-table">
                <TableContainer component={Paper}>
                    <Table sx={{minWidth: 650}} aria-label="simple table">
                        <TableHead>
                            <TableRow>
                                <TableCell className="table-head">Название компании</TableCell>
                                <TableCell className="table-head" align="right">Приложения</TableCell>
                                <TableCell className="table-head" align="right">Филиалы</TableCell>
                                <TableCell className="table-head" align="right">Сотрудники</TableCell>
                                <TableCell className="table-head" align="right">Админы</TableCell>
                                <TableCell className="table-head" align="right">Действие</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {offices?.map((item) => (<TableRow
                                    key={item.name}
                                    sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                >
                                    <TableCell component="th" scope="row">
                                        <span className="t-name font-family-medium">{item?.name}</span>
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row">
                                        <span className="t-name font-family-medium">{item?.name}</span>
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row">
                                        <span className="t-name font-family-medium">{item?.name}</span>
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row">
                                        <span className="t-name font-family-medium">{item?.name}</span>
                                    </TableCell>
                                    <TableCell component="th" align="right" scope="row">
                                        <span className="t-name font-family-medium">{item?.name}</span>
                                    </TableCell>
                                    <TableCell className="twt" align="right">
                                        <div className="con-btns-all">
                                            <div className="con-btns-all">
                                                <button className="t-block-btn font-family-medium"
                                                        onClick={() => selectCompany(item?.id)}>Просмотр
                                                </button>

                                                <button className="t-delete-btn font-family-medium"
                                                        onClick={() => showModalDelete(item?.id)}>Удалить
                                                </button>

                                                <button className="t-edit-btn font-family-medium"
                                                        onClick={() => editPage(item.id)}>Изменить
                                                </button>
                                            </div>
                                        </div>
                                    </TableCell>
                                </TableRow>))}
                        </TableBody>
                    </Table>
                </TableContainer>

            </div>

            <Modal title="Внимание!"
                   open={isModalOpen}
                   onCancel={handleCancelDelete}
                   footer={[<Button key="submit" type="default" onClick={handleCancelDelete}>
                       Отменить
                   </Button>, <Button key="submit" type="danger" className="my-red-canc" onClick={handleOkDelete}>
                       Да, удалить
                   </Button>]}
            >
                <p className="pt-2 pb-2 text-white">Вы уверены, что удалите этого филиаля? Это невозможно отменить</p>
            </Modal>


            <div className="pag-bottom">
                {/*<Stack spacing={2}>*/}
                {/*<Pagination count={officesObj?.pages} total={officesObj?.total} current={current}*/}
                {/*            onChange={changePagination} shape="rounded"/>*/}
                {/*    <Pagination  count={3}   total={offices.length} current={current}  onChange={changePagination} shape="rounded"/>*/}
                {/*</Stack>*/}
            </div>
            {
                loader
                    ?

                    <div className="my-loader">
                        <Spin size="large" />
                    </div>
                    :
                    ""
            }
        </div>
    );
};

export default AdminCompanies;